import AdminLayout from "../../components/admin/AdminLayout";
import SubmissionsTable from "../../components/admin/SubmissionsTable";

export default function AdminCareers() {
  return (
    <AdminLayout title="Career Submissions" subtitle="Inquiries from the careers form.">
      <SubmissionsTable type="careers" />
    </AdminLayout>
  );
}
